import {
    REQUEST_DISCOUNT_ROLLOUT,
    RECEIVE_DISCOUNT_ROLLOUT,
    RESET_DISCOUNT_ROLLOUT,
} from '../actions/discountServiceTypes.js';

/**
 * The organization's discount-service rollout switch, `huskyCloudSettings.useNewDiscountApi` from root API
 * `/v3/organization/myselfly-settings` — the same flag cabinet.backend.3 uses to pick its discount source.
 * Read it through `newDiscountApiEnabled` in `services/discountSource.js`, which also checks `groupId`.
 */
export const initState = {
    fetching: false,
    fetched: false,
    useNewDiscountApi: false,
    /** The `user.group.Id` this was read for, so an org switch invalidates it. */
    groupId: null,
};

export default function discountRollout(state = initState, action) {
    switch (action.type) {
        case REQUEST_DISCOUNT_ROLLOUT:
            return { ...state, fetching: true, fetched: false, groupId: action.groupId };
        case RECEIVE_DISCOUNT_ROLLOUT:
            // A failed read arrives here as `false`, like the cabinet: an unreadable flag never switches cds on.
            return {
                ...state,
                fetching: false,
                fetched: true,
                useNewDiscountApi: action.useNewDiscountApi === true,
                groupId: action.groupId,
            };
        case RESET_DISCOUNT_ROLLOUT:
            return { ...initState };
        default:
            return state;
    }
}
